var _g, _rect, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlocks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M175,200H25c-13.807,0-25-11.193-25-25V25C0,11.193,11.193,0,25,0h150c13.807,0,25,11.193,25,25v150 C200,188.807,188.807,200,175,200z M25,16.656c-4.601,0.017-8.327,3.743-8.344,8.344v150c0.017,4.602,3.743,8.326,8.344,8.344h150 c4.602-0.018,8.326-3.742,8.344-8.344V25c-0.018-4.601-3.742-8.327-8.344-8.344H25z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 48.796,
    fill: "#FFFFFF",
    width: 109,
    height: 33.136
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 100.244,
    fill: "#FFFFFF",
    width: 44.472,
    height: 47.96
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 110.028,
    y: 100.244,
    fill: "#D1E7F2",
    width: 44.472,
    height: 47.96
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocks);
export default __webpack_public_path__ + "static/media/blocks.eea2c0221903ed1d841882f5e548a7ab.svg";
export { ForwardRef as ReactComponent };